export default __webpack_public_path__ + "static/media/link.8524beec.mp3";